class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.buyButtonsBlock = null;
    this.addToCartButton = null;
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.buyButtonsBlock = document.querySelector('.buy-buttons-block');
    if (!this.buyButtonsBlock) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.classList.toggle('visible', !entry.isIntersecting);
        });
      },
      { threshold: 0, rootMargin: '0px' }
    );

    this.observer.observe(this.buyButtonsBlock);

    const button = this.querySelector('button[type="submit"]');
    if (button) {
      this.addToCartButton = button;
      button.addEventListener('click', this.handleAddToCart.bind(this));
    }

    document.addEventListener('variant:update', this.handleVariantUpdate.bind(this));
  }

  disconnectedCallback() {
    if (this.observer && this.buyButtonsBlock) {
      this.observer.unobserve(this.buyButtonsBlock);
    }
    document.removeEventListener('variant:update', this.handleVariantUpdate.bind(this));
  }

  handleAddToCart(event) {
    event.preventDefault();
    const mainForm = document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    const submitButton = mainForm?.querySelector('button[type="submit"]');
    submitButton?.click();
  }

  handleVariantUpdate(event) {
    const { resource } = event.detail || {};
    if (!this.addToCartButton) return;

    // Get the main button that was already updated by product-form-component
    const mainButton = document.querySelector('.buy-buttons-block button[name="add"]');
    if (!mainButton) return;

    const isAvailable = resource != null && resource.available !== false;

    // Sync disabled state
    this.addToCartButton.disabled = !isAvailable;

    // Copy the entire button content from the main button
    this.addToCartButton.innerHTML = mainButton.innerHTML;

    // Re-attach click handler since we replaced innerHTML
    this.addToCartButton.addEventListener('click', this.handleAddToCart.bind(this));
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);

